export const filterItems = (items: any) =>
    items.filter(({ id }, index: number) => !items.map((item: any) => item.id).includes(id, index + 1));
